import { gql } from '@apollo/client'
import type { UseMutationProps } from '@ztechapps/common.hook'
import { useMutation } from '@ztechapps/common.hook'
import type { Logistic, StateTransitionArgs } from '@ztechapps/common.contract'
import { logisticFragment } from './graphql'

export const changeLogisticStatusQuery = gql`
  ${logisticFragment}
  mutation changeLogisticStatus($input: StateTransitionArgs!) {
    changeLogisticStatus(input: $input) {
      ...logisticFragment
    }
  }
`

export const useChangeLogisticStatus = (args?: Omit<UseMutationProps, 'query'>) => {
  return useMutation<{ changeLogisticStatus: Logistic }, StateTransitionArgs<Logistic>>({
    query: changeLogisticStatusQuery,
    ...args,
  })
}
